import { Link, isRouteErrorResponse, useRouteError } from "react-router";
import { useSEO } from "@/hooks/useSEO";

export default function RouteErrorPage() {
  useSEO({ title: "Page Not Found", noIndex: true });
  const error = useRouteError();

  let title = "Something went wrong";
  let message = "An unexpected error occurred while loading this page.";

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    message = typeof error.data === "string" ? error.data : message;
  } else if (error instanceof Error && error.message) {
    message = error.message;
  }

  return (
    <div className="min-h-screen bg-[#0a0a12] text-zinc-100 flex items-center justify-center px-6">
      <div className="w-full max-w-lg rounded-2xl border border-white/10 bg-white/5 p-8 backdrop-blur-sm">
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        <p className="mt-3 text-sm text-zinc-300">{message}</p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link
            to="/"
            className="rounded-md bg-fuchsia-600 px-4 py-2 text-sm font-medium text-white hover:bg-fuchsia-500"
          >
            Go to Home
          </Link>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-md border border-white/20 px-4 py-2 text-sm font-medium text-zinc-200 hover:bg-white/10"
          >
            Reload Page
          </button>
        </div>
      </div>
    </div>
  );
}
